<template>
  <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
</template>

<script>
export default {
  name: "AdminBreadcrumbs",

  props: {
    vendor: {
      type: Object,
      required: false,
      default: null,
    },
    items: {
      type: Array,
      required: false,
      default: null,
    },
    tailText: {
      type: String,
      required: false,
      default: null,
    },
  },

  computed: {
    user() {
      return this.$store.state.auth;
    },
    breadcrumbs() {
      var crumbs = [];

      crumbs.push({
        text: this.user.organization.name,
        disabled: false,
        to: { name: "admin" },
        exact: true,
      });

      if (this.vendor !== null && typeof this.vendor.name !== "undefined") {
        crumbs.push({
          text: this.vendor.name,
          disabled: false,
          to: {
            name: "adminVendorDetail",
            params: { vendorId: this.vendor.id.toString() },
          },
          exact: true,
        });
      }

      if (this.tailText) {
        crumbs.push({
          text: this.tailText,
          disabled: true,
        });
      }

      if (this.items) {
        return [...crumbs, ...this.items];
      }

      return crumbs;
    },
  },
};
</script>

<style scoped>
.v-breadcrumbs {
  padding-left: 0;
}
</style>
